module.exports = __webpack_public_path__ + "static/media/instagram.4a60e1df.svg";